<template>
  <div v-if="show" :style="wrapperStyle">
    <v-alert
      v-model="alertShow"
      :type="type"
      prominent
      border="left"
      colored-border
      elevation="2"
      dismissible
      @input="onClose"
    >
      <v-icon left>{{ alertIcon }}</v-icon>
      <span>{{ text }}</span>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      validator: value => ['info', 'warning', 'error'].includes(value)
    }
  },
  data() {
    return {
      alertShow: this.show,
      autoCloseTimer: null
    };
  },
  computed: {
    wrapperStyle() {
      return `
        position: fixed;
        left: 50%;
        top: 65%;
        transform: translate(-50%, -50%);
        z-index: 9999;
        width: 400px;
        max-width: 90vw;
      `;
    },
    alertIcon() {
      const iconMap = {
        info: 'mdi-information',
        warning: 'mdi-alert',
        error: 'mdi-alert-circle'
      };
      return iconMap[this.type] || iconMap.info;
    }
  },
  watch: {
    show(val) {
      this.alertShow = val;
      if (val) {
        this.startAutoClose();
      } else {
        this.clearAutoClose();
      }
    }
  },
  methods: {
    onClose() {
      this.clearAutoClose();
      this.$emit('close');
    },
    startAutoClose() {
      this.clearAutoClose();
      const timeoutMap = {
        info: 2500,      // info: 2.5秒
        warning: 3500,   // warning: 3.5秒
        error: 3500      // error: 3.5秒
      };
      this.autoCloseTimer = setTimeout(() => {
        this.alertShow = false;
        this.$emit('close');
      }, timeoutMap[this.type] || 3000);
    },
    clearAutoClose() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
    }
  },
  mounted() {
    if (this.show) {
      this.startAutoClose();
    }
  },
  beforeDestroy() {
    this.clearAutoClose();
  }
};
</script>

<style scoped>
/* 確保 alert 在最上層 */
</style>
